export const upcomingEvents = [
  {
    id: 1,
    title: "Café & Conexão: Mulheres que Transformam",
    description: "Um encontro intimista para mulheres empreendedoras e profissionais trocarem experiências, fortalecerem suas redes de apoio e descobrirem novas oportunidades de colaboração. Teremos uma dinâmica de apresentação, roda de conversa e um momento especial de mentoria coletiva.",
    image_url: "/img/readdy/0fad76a30a5c.jpg",
    event_datetime: "2026-08-15T09:00:00-03:00",
    location: "Café Girassol — Rua das Flores, 342, Jardim Paulista, São Paulo/SP",
    max_spots: 20,
    active: true,
    unique_link_slug: "cafe-e-conexao-mulheres-que-transformam",
    created_at: "2026-07-10T14:30:00-03:00",
  },
  {
    id: 2,
    title: "Oficina: Finanças com Propósito",
    description: "Uma manhã dedicada a despertar a sua relação com o dinheiro de forma leve e prática. Vamos falar sobre planejamento financeiro pessoal, independência econômica e como alinhar suas finanças aos seus valores e propósito de vida. Traga papel e caneta!",
    image_url: "/img/readdy/271818f14bf4.jpg",
    event_datetime: "2026-09-20T09:00:00-03:00",
    location: "Espaço Colabora — Av. Paulista, 1000, 8º andar, São Paulo/SP",
    max_spots: 15,
    active: true,
    unique_link_slug: "oficina-financas-com-proposito",
    created_at: "2026-07-15T10:00:00-03:00",
  },
];